export default __webpack_public_path__ + "static/media/e-filing-logotype-d.1fac77d2.svg";